import type { SkinViews } from '~/core/skin'

import { BATCH_TIMEOUT } from './index.h'
import { SkinBatchLoader } from './loader'

const loader = new SkinBatchLoader<SkinViews>('/api/era/skin', BATCH_TIMEOUT)
const resolved = new WeakMap<Promise<SkinViews>, SkinViews>()

export function skin(path: string): Promise<SkinViews> {
  const promise = loader.get(path)
  promise.then(
    (views) => resolved.set(promise, views),
    () => undefined
  )
  return promise
}

export function getResolvedSkin(
  promise: Promise<SkinViews>
): SkinViews | undefined {
  return resolved.get(promise)
}
